import React, { useEffect, useRef } from "react";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

function CharFadeIn({ text, className = "", ...rest }) {
    const containerRef = useRef(null);

    // Extract text color from className
    const getTextColor = () => {
        if (className.includes("text-black")) return "#000";
        if (className.includes("text-white")) return "#fff";
        if (className.includes("text-gray-300")) return "#d1d5db";
        if (className.includes("text-gray-400")) return "#9ca3af";
        return "#fff"; // default
    };

    const textColor = getTextColor();

    // Split text into words and characters for rendering
    const words = text.split(/(\s+)/).map((word, wIdx) => {
        if (/^\s+$/.test(word)) return word; // preserve whitespace
        return (
            <span key={wIdx} style={{ display: "inline-block", whiteSpace: "pre" }}>
        {Array.from(word).map((char, cIdx) => (
            <span
                key={cIdx}
                className="char-fade"
                style={{
                    opacity: 0,
                    color: "#bbb",
                    filter: "blur(2px)",
                    display: "inline-block",
                }}
            >
            {char}
          </span>
        ))}
      </span>
        );
    });

    useEffect(() => {
        const container = containerRef.current;
        if (!container) return;

        const chars = container.querySelectorAll(".char-fade");
        if (!chars.length) return;

        chars.forEach((span) => {
            span.style.opacity = 0;
            span.style.color = "#bbb";
            span.style.filter = "blur(2px)";
        });

        const d = container.dataset || {};
        const delayVal = d.delay ? parseFloat(d.delay) : 0.2;
        const staggerEachVal = d.staggerEach ? parseFloat(d.staggerEach) : 0.01;
        const staggerAmountVal = d.staggerAmount
            ? parseFloat(d.staggerAmount)
            : 0.7;

        // 👇 Only animate when the section is 60% visible
        gsap.to(chars, {
            scrollTrigger: {
                trigger: container,
                start: "top 60%", // Start animation when 60% of section is visible
                end: "bottom 40%", // Optional: control when animation completes
                once: true,
            },
            opacity: 1,
            color: textColor,
            filter: "blur(0px)",
            duration: 0.3,
            stagger: {
                each: staggerEachVal,
                amount: staggerAmountVal,
            },
            ease: "power2.out",
            delay: delayVal,
            onComplete: () => {
                chars.forEach((span) => {
                    span.style.opacity = 1;
                    span.style.color = textColor;
                    span.style.filter = "blur(0px)";
                });
            },
        });
    }, [text, textColor]);

    return (
        <span ref={containerRef} className={className} {...rest}>
      {words}
    </span>
    );
}

export default CharFadeIn;
